import './style.css';
import Application from './Application/Application';
// Detect mobile devices
function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
        (window.innerWidth <= 768);
}
// If mobile, redirect to mobile version
if (isMobileDevice() && window.location.pathname === '/') {
    // Redirect to mobile version (portfolio-os.html directly)
    window.location.href = '/portfolio-os.html';
}
else {
    // Desktop version with 3D
    const app = new Application();
}
